import { SuccessSwal, SwalPost } from "../../app";

$(function () {
  const body = $("body");

  if (body.hasClass("banned-ip-list")) {
    const table = $("#bannedIpsTable");
    const form = $("#bannedIpsFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        $(nRow).find("td:last-of-type").append(`
          <button data-id="${aData["id"]}" class="deleteBannedIp btn btn-sm btn-danger">Ban-dan çıxart / Sil</button>
        `);
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
    });

    $(document).on("click", ".deleteBannedIp", (e) => {
      e.preventDefault();
      const id = $(e.currentTarget).data("id");
      const url = id + "/delete/";
      SwalPost(
        url,
        {},
        {
          text: "Ban olunmuş IP-ni silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then(() => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          table.DataTable().ajax.reload();
        });
      });
    });
  }
});
